import { DataType } from '@wix/editor-platform-ooi-metadata-resolver';
import { createSettingsParams, SettingsParamType } from '@wix/tpa-settings';

export type ISettingsParams = {
  pageTitle: SettingsParamType.Text;
  pageTitleTag: SettingsParamType.String;
  pageDescription: SettingsParamType.Text;
  pageDescriptionTag: SettingsParamType.String;
  getButton: SettingsParamType.Text;
  copyButton: SettingsParamType.Text;
  tiersCurrentTierTitleTag: SettingsParamType.String;
  tiersTierNameTag: SettingsParamType.String;
  totalPointsTitleTag: SettingsParamType.String;
  totalPointsExpirationTag: SettingsParamType.String;
  rewardsRewardTitleTag: SettingsParamType.String;
  rewardsRewardTextTag: SettingsParamType.String;
  emptyStateTitleTag: SettingsParamType.String;
  emptyStateSubtitleTag: SettingsParamType.String;
};

export default createSettingsParams<ISettingsParams>({
  pageTitle: {
    type: SettingsParamType.Text,
    getDefaultValue: ({ t }) => t('app.settings.defaults.pageTitle'),
    metadata: ({ t }) => ({
      type: DataType.text,
      defaultValue: { type: 'static', value: t('app.settings.defaults.pageTitle') },
      ai: { description: 'Page title of the My Rewards widget' },
    }),
  },
  pageTitleTag: {
    type: SettingsParamType.String,
    getDefaultValue: () => 'h1',
  },
  pageDescription: {
    type: SettingsParamType.Text,
    getDefaultValue: ({ t }) => t('app.settings.defaults.pageDescription'),
    metadata: ({ t }) => ({
      type: DataType.text,
      defaultValue: { type: 'static', value: t('app.settings.defaults.pageDescription') },
      ai: { description: 'Page description of the My Rewards widget' },
    }),
  },
  pageDescriptionTag: {
    type: SettingsParamType.String,
    getDefaultValue: () => 'p',
  },
  getButton: {
    type: SettingsParamType.Text,
    getDefaultValue: ({ t }) => t('app.settings.defaults.button-get'),
    metadata: ({ t }) => ({
      type: DataType.text,
      defaultValue: { type: 'static', value: t('app.settings.defaults.button-get') },
      ai: { description: 'Primary button text for claiming a reward' },
    }),
  },
  copyButton: {
    type: SettingsParamType.Text,
    getDefaultValue: ({ t }) => t('app.settings.defaults.button-copy'),
    metadata: ({ t }) => ({
      type: DataType.text,
      defaultValue: { type: 'static', value: t('app.settings.defaults.button-copy') },
      ai: { description: 'Button text for copying a coupon code' },
    }),
  },
  tiersCurrentTierTitleTag: {
    type: SettingsParamType.String,
    getDefaultValue: () => 'p',
  },
  tiersTierNameTag: {
    type: SettingsParamType.String,
    getDefaultValue: () => 'p',
  },
  totalPointsTitleTag: {
    type: SettingsParamType.String,
    getDefaultValue: () => 'p',
  },
  totalPointsExpirationTag: {
    type: SettingsParamType.String,
    getDefaultValue: () => 'p',
  },
  rewardsRewardTitleTag: {
    type: SettingsParamType.String,
    getDefaultValue: () => 'h3',
  },
  rewardsRewardTextTag: {
    type: SettingsParamType.String,
    getDefaultValue: () => 'p',
  },
  emptyStateTitleTag: {
    type: SettingsParamType.String,
    getDefaultValue: () => 'h2',
  },
  emptyStateSubtitleTag: {
    type: SettingsParamType.String,
    getDefaultValue: () => 'p',
  },
});
